<div class="building-details">
  <div class="building-type">
    <label class="value" *ngIf="!!authService.permissions.BUILDING_TYPE || !!authService.permissions.BUILDING_TYPE_UPDATE">
      {{ data?.buildingType ? data.buildingType?.name : '' }}
    </label>
  </div>
  <div class="header">
    <label class="name" matTooltip="{{ data?.name }}" [matTooltipShowDelay]="showDelay.value" [matTooltipHideDelay]="hideDelay.value">{{ data?.name }}</label>
  </div>
  <div class="location">
    <div class="address">
      <div class="identifier">{{ 'module.energyMap.descriptionComponent.address' | translate }}</div>
      <div class="value">{{ data | getAddress }}</div>
    </div>
    <div class="coordinates">
      <div class="identifier">
        GPS Standort
        <span class="fa fa-history" (click)="openHistoryDialog()" aria-hidden="true"></span>
      </div>
      <div class="value">
        BREITE <span class="value">{{ data?.latitude }}</span>
      </div>
      <div class="value">
        LÄNGE <span class="value">{{ data?.longitude }}</span>
      </div>
    </div>
  </div>
  <div class="button-container">
    <button type="button" class="btn btn-primary" id="edit-name" (click)="editBuilding()" *ngIf="authService.permissions.BUILDING_TYPE_UPDATE">
      <span class="fa fa-pencil-square-o" aria-hidden="true" id="edit-icon"></span>
      <span class="btn-text">
        {{ data?.buildingType ? 'Bearbeiten' : 'Identifiziere Gebäudetyp' }}
      </span>
    </button>
  </div>
  <div class="identifier">Kommentar</div>
  <p class="description">
    {{
      data?.description !== '' && data?.description !== null ? data?.description : ('module.energyMap.descriptionComponent.commentPlaceholderText' | translate)
    }}
  </p>
</div>
